import { Component,ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../Core/services/api.services';
import { take } from 'rxjs/operators';
import {UserDetailComponent} from '../user-detail-ctl/user-detail-ctl.component';
import { environment } from 'src/environments/environment.development';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { UserService } from 'src/app/Core/services/user.service';

@Component({
  selector: 'app-user-search',
  templateUrl: './user-search-ctl.component.html',
  styleUrls: ['./user-search-ctl.component.css']
})
export class UserSearchComponent {
  @ViewChild(UserDetailComponent) userDetailComponent!: UserDetailComponent;
  filter: string = 'email';
  searchText: string = '';
  userID: any = '';
  selectedUserId : string | null = null; //variable to store the selected userID
  dataFetched: boolean = false;
  userOptions = [
    { value: 'email', label: 'E-Mail' },
    { value: 'id', label: 'User ID' }
  ];

  constructor(private router: Router,private http: HttpClient,private route: ActivatedRoute, private userService: UserService){
    this.route.paramMap.forEach((params) => {
      this.userID = params.get("id")!
    });
  }

  getFilteredUserOptions() {
    return this.userOptions.filter(userOptions => userOptions.value !== this.filter);
  }

  getUserOptionLabel(value: string): string {
    const found = this.userOptions.find(userOptions => userOptions.value === value);
    return found ? found.label : value;
  }

  onFilterChange(): void {
    // Clear the search text when the filter changes
    this.userDetailComponent.dataFetched=false;
    this.dataFetched=false;
    this.searchText = '';
    this.userDetailComponent.rowData = [];
  }

  onSearchClick(): void {
    if (this.filter === 'id') {
      if (!this.searchText.trim()) {
        this.userDetailComponent.rowData = [];
        this.dataFetched = true;
        return;
      }
  
      // Construct the endpoint with the selected userID
      if (!this.isValidUserID(this.searchText.trim())) {
        alert('Please enter a valid user id.');
        return;
      }
      this.userID = this.searchText;
      this.userService.searchUserByID(this.userID).subscribe(
        (data) => {
          this.userDetailComponent.rowData = [data];
          this.dataFetched = true;
        },
        (error) => {
          console.error('Error fetching the user information with ID', error);
          this.userDetailComponent.rowData = [];
          this.dataFetched = true;
        }
      );
    } else {
      this.userDetailComponent.onSearchClick();
    }
  }

  isValidUserID(userID: string): boolean {
    // Regular expression for userID validation
    const userIDRegex = /^\d+$/;
    return userIDRegex.test(userID);
  }
  
}
